import { PageHeader } from '@@/PageHeader';

import { VulnerabilitiesDatatable } from './VulnerabilitiesDatatable/VulnerabilitiesDatatable';

export function VulnerabilitiesView() {
  return (
    <>
      <PageHeader
        title="Image vulnerabilities"
        breadcrumbs={[{ label: 'Image vulnerabilities' }]}
        reload
      />
      <VulnerabilitiesDatatable />
    </>
  );
}
